import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { db } from '../firebase';
import { doc, getDoc, updateDoc, arrayUnion } from 'firebase/firestore';

/**
 * Inicializa y registra las notificaciones push para el usuario autenticado.
 * @param {string} uid El ID del usuario actual de Firebase
 */
export const registerPushNotifications = async (uid) => {
    // Solo registrar si estamos en un dispositivo móvil (Capacitor nativo)
    if (!Capacitor.isNativePlatform()) {
        console.log('PUSH_NOTIFS: No es plataforma nativa, se omite el registro de Push Notifications.');
        return;
    }

    try {
        console.log('PUSH_NOTIFS: Solicitando permisos para Push Notifications...');
        let permStatus = await PushNotifications.checkPermissions();

        if (permStatus.receive === 'prompt') {
            permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
            console.warn('PUSH_NOTIFS: Permiso denegado por el usuario.');
            return;
        }

        // Registrar con FCM (Apple APNs en iOS o Google FCM en Android)
        await PushNotifications.register();
        console.log('PUSH_NOTIFS: Registro exitoso en el sistema de notificaciones.');

        // Escuchar cuando se genera el token
        PushNotifications.addListener('registration', async (token) => {
            console.log('PUSH_NOTIFS: Token generado:', token.value);
            // Guardar token en Firestore
            await saveFCMTokenToFirestore(uid, token.value);
        });

        // Escuchar errores de registro
        PushNotifications.addListener('registrationError', (error) => {
            console.error('PUSH_NOTIFS: Error en el registro del dispositivo', JSON.stringify(error));
        });

        // Escuchar notificaciones recibidas en primer plano (app abierta)
        PushNotifications.addListener('pushNotificationReceived', (notification) => {
            console.log('PUSH_NOTIFS: Notificación recibida en primer plano:', notification);
            // Aquí podrías disparar un Custom Event o usar un Context para mostrar una alerta UI
        });

        // Escuchar clics en la notificación (app en segundo plano / cerrada)
        PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
            console.log('PUSH_NOTIFS: Usuario interactuó con la notificación:', notification);
            
            const data = notification.notification.data;
            if (data && data.tipo === 'chat_mensaje' && data.referenciaId) {
                // Redirigir al chat comunitario con el ID de la conversación
                window.location.href = `/comunidad/chat?conversationId=${data.referenciaId}`;
            }
        });

    } catch (error) {
        console.error('PUSH_NOTIFS: Error inicializando notificaciones push', error);
    }
};

/**
 * Guarda el token de FCM en el documento del usuario en Firestore.
 * Utiliza un array para soportar múltiples dispositivos del mismo usuario.
 */
const saveFCMTokenToFirestore = async (uid, fcmToken) => {
    if (!uid || !fcmToken) return;

    try {
        const userRef = doc(db, 'usuarios', uid);
        const userDoc = await getDoc(userRef);

        if (userDoc.exists()) {
            await updateDoc(userRef, {
                fcmTokens: arrayUnion(fcmToken)
            });
            console.log('PUSH_NOTIFS: Token FCM guardado/actualizado en Firestore exitosamente.');
        } else {
            console.warn('PUSH_NOTIFS: Documento de usuario no encontrado, no se guardó el token.');
        }
    } catch (error) {
        console.error('PUSH_NOTIFS: Error guardando token FCM en Firestore', error);
    }
};
